export const DISCORD_WEBHOOK_TEMPLATE_NAME = '__discord_webhook__';

export function getWebhookFromProposalTemplates(templates) {
  const entry = (templates || []).find(t => t?.name === DISCORD_WEBHOOK_TEMPLATE_NAME);
  return (entry?.url || '').trim();
}

export function mergeWebhookIntoProposalTemplates(templates, webhookUrl) {
  const visible = (templates || []).filter(t => t?.name && t.name !== DISCORD_WEBHOOK_TEMPLATE_NAME);
  const url = (webhookUrl || '').trim();
  if (url) visible.push({ name: DISCORD_WEBHOOK_TEMPLATE_NAME, url });
  return visible;
}

export function readDiscordWebhookUrl(cfg) {
  return (cfg?.discordWebhookUrl || '').trim() || getWebhookFromProposalTemplates(cfg?.proposalTemplates);
}

export function visibleProposalTemplates(templates) {
  return (templates || [])
    .map(t => (typeof t === 'string' ? { name: t, url: '' } : t))
    .filter(t => t?.name && t.name !== DISCORD_WEBHOOK_TEMPLATE_NAME);
}
